export default [
  {
    key: 'asterisk',
    label: 'Asterisk',
  },
  {
    key: 'bars',
    label: 'Bars',
  },
  {
    key: 'file',
    label: 'File',
  },
  {
    key: 'globe',
    label: 'Globe',
  },
  {
    key: 'building',
    label: 'Building',
  },
  {
    key: 'plane',
    label: 'Plane',
  },
  {
    key: 'map-marker',
    label: 'Map Marker',
  },
  {
    key: 'archive',
    label: 'Archive',
  },
  {
    key: 'money-bill',
    label: 'Money',
  },
  {
    key: 'tag',
    label: 'Tag',
  },
  {
    key: 'paper-plane',
    label: 'Paper plane',
  },
  {
    key: 'key',
    label: 'Key',
  },
  {
    key: 'file-pdf',
    label: 'PDF',
  },
  {
    key: 'envelope',
    label: 'Envelope',
  },
  {
    key: 'user',
    label: 'User',
  },
  {
    key: 'database',
    label: 'Database',
  },
  {
    key: ['fab', 'wordpress-simple'],
    label: 'Wordpress Simple',
  },
];
